import "core-js/stable";
import "regenerator-runtime/runtime";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route } from 'react-router';
import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import rootSaga from './sagas';
import createRootReducer from './reducers';
import { getRoutes } from './routes';
import App from './App';
import { createBrowserHistory } from 'history';
import HttpsRedirect from './components/auth/HttpsRedirect';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import 'flexboxgrid/dist/flexboxgrid.min.css';
import './styles/index.css';
import { datadogRum } from '@datadog/browser-rum';

var getEnv = function () {
  var regex = /\.(.*)\.(defisolutions|defiapps).com/;
  var envMatch = window.location.host.match(regex);
  if (!envMatch)
    return "prod"
  else
    return envMatch[1]
}

datadogRum.init({
  applicationId: '714d1bcc-3aed-4186-b04e-d9690bf8b029',
  clientToken: 'pub127ada0635951daaf22f4a47012706fe',
  site: 'datadoghq.com',
  service: 'defi-ui',
  env: getEnv(),
  // Specify a version number to identify the deployed version of your application in Datadog 
  // version: '1.0.0',
  sampleRate: 100,
  trackInteractions: false
});

const customHistory = createBrowserHistory({
  basename: ''
});


const sagaMiddleware = createSagaMiddleware();
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  createRootReducer(customHistory),
  composeEnhancer(applyMiddleware(sagaMiddleware, routerMiddleware(customHistory)))
);

const AppContext = React.createContext();
sagaMiddleware.run(rootSaga);

class Main extends Component {
  render() {
    return (
      <Provider store={store} context={AppContext} >
        <ConnectedRouter basename="" onUpdate={() => window.scrollTo(0, 0)} history={customHistory} context={AppContext}>
          <HttpsRedirect>
            <App history={customHistory} context={AppContext}>
              <Switch >
                {getRoutes.map(({ path, form, content: ContentComponent }) => (
                  <Route
                    location={customHistory.location}
                    key={path}
                    exact
                    form={form}
                    path={path}
                    render={props => <ContentComponent context={AppContext} {...props} />}
                  />
                ))}
              </Switch>
            </App>
          </HttpsRedirect>
        </ConnectedRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<Main />, document.getElementById('root'));
